var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isloading),expression:"isloading"}],staticClass:"loader"},[_c('img',{attrs:{"src":require("../../assets/logo.png"),"alt":"Carregando..."}}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"dot1"}),_c('div',{staticClass:"dot2"})])
}]

export { render, staticRenderFns }